import reduce from 'ramda/src/reduce';
import omit from 'ramda/src/omit';
import {
  ADD_DISCOUNT,
  DELETE_DISCOUNT,
  EDIT_DISCOUNT,
  FETCH_DISCOUNTS,
} from './constants';

const transformDiscountItem = item => ({
  ...item,
  assignment: item.assignment || '',
});
const mapDiscounts = reduce((result, item) => ({
  ...result,
  [item.id]: transformDiscountItem(item),
}), {});

const discounts = (state = {}, action) => {
  switch (action.type) {
    case FETCH_DISCOUNTS: {
      if (action.payload.length === 0) {
        return {};
      }
      return mapDiscounts(action.payload);
    }
    case ADD_DISCOUNT:
    case EDIT_DISCOUNT:
      return {
        ...state,
        [action.payload.id]: transformDiscountItem(action.payload),
      };
    case DELETE_DISCOUNT:
      return omit([action.payload], state);
    default:
      return state;
  }
};

export default discounts;
